module.exports = __webpack_public_path__ + "img/Hair-Clip.6e12bf77.jpg";